import { Box, Button, DialogProps } from "@mui/material";
import useWorkflows from "../../../hooks/useWorkflows";
import BasicModal from "../../components/modal/BasicModal";
import { useSnackbarHelper } from "../../components/Snackbar";

interface Props extends DialogProps {
  onClose: () => void;
  workflowId?: string;
  taskId?: string;
}

const DeleteWorkflowTodoModal = ({
  onClose,
  workflowId,
  taskId,
  ...props
}: Props) => {
  const { deleteWorkflowTodo, isDeletingWorkflowTodo } = useWorkflows(
    workflowId,
    taskId
  );

  const showSnackbar = useSnackbarHelper();

  const onSubmit = async () => {
    try {
      const data = await deleteWorkflowTodo();

      const message = data?.message || "Success";

      showSnackbar(message, "success");

      onClose();
    } catch (error: any) {
      const message = error?.response?.data?.message || "An error occurred";

      showSnackbar(message, "error");
    }
  };

  return (
    <Box>
      <BasicModal
        onClose={onClose}
        title="Delete To do"
        content="Do you really want to delete this todo? "
        actions={
          <>
            <Button
              variant="contained"
              color="error"
              sx={{ textTransform: "capitalize" }}
              onClick={onSubmit}
              disabled={isDeletingWorkflowTodo}
            >
              Delete
            </Button>
            <Button
              color="error"
              variant="outlined"
              sx={{ textTransform: "capitalize" }}
              onClick={() => onClose()}
            >
              Cancel
            </Button>
          </>
        }
        {...props}
      />
    </Box>
  );
};

export default DeleteWorkflowTodoModal;
